const Title = () => {
  return (
    <div className="flex w-full items-end justify-center">
      <div className="flex w-[1153px] flex-col items-center px-5">
        <p className="text-center text-lg text-slate-300">
          Take proactive steps against PII based attacks on your orgnization with Redact for
          business. Automate the removal of all content types from 35+ social media platforms & 100+
          data brokers. <br />
        </p>
      </div>
    </div>
  );
};

export default Title;
